import {
	isInTest,
} from '../test';

export const isMobile = (): boolean => {
	if (isInTest()) {
		return false;
	}
	const isMobile = window.matchMedia('only screen and (max-width: 760px)');
	return isMobile.matches ? true : false;
};